import {
  USER_TYPE_EDIT, USER_TYPE_EDIT_FAILURE, USER_TYPE_EDIT_SUCCESS, USER_TYPE_UPDATE, USER_TYPE_UPDATE_FAILURE, USER_TYPE_UPDATE_SUCCESS
} from './mutation-types'

export default {
  state: {
    user_type: null,
    user_type_business_type: null
  },
  getters: {
    edit_user_type: state => {
      return state.user_type
    },
    user_type_business_type: state => {
      return state.user_type_business_type
    }
  },
  actions: {
    [USER_TYPE_EDIT] ({dispatch, state, commit}, params = null) {
      var data = params.data
      var callback = null
      if (data) {
        callback = data.callback
      }
      var url = '/master/user_types/' + params.id
      dispatch('apiGet', {url: url, data: {user_type_id: params.user_type_id}, loadparams: true})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(USER_TYPE_EDIT_FAILURE, res.data)
            } else {
              res.data.callback = callback
              commit(USER_TYPE_EDIT_SUCCESS, res.data)
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [USER_TYPE_UPDATE] ({dispatch, state, commit}, params = null) {
      var data = params.data
      var url = '/master/user_types/' + params.id
      dispatch('apiPatch', {url: url, data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(USER_TYPE_UPDATE_FAILURE, res.data)
            } else {
              commit(USER_TYPE_UPDATE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    }
  },
  mutations: {
    [USER_TYPE_EDIT_FAILURE] (state, data) {
      console.log('USER_TYPE_EDIT_FAILURE')
    },
    [USER_TYPE_EDIT_SUCCESS] (state, data) {
      console.log('USER_TYPE_EDIT_SUCCESS')
      state.user_type = data.user_type
      state.user_type_business_type = data.business_type
      if (data.callback) {
        data.callback()
      }
    },
    [USER_TYPE_UPDATE_FAILURE] (state, data) {
      console.log('USER_TYPE_UPDATE_FAILURE')
    },
    [USER_TYPE_UPDATE_SUCCESS] (state, data) {
      console.log('USER_TYPE_UPDATE_SUCCESS')
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/usertype-edit.js